// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3PDHp","content":"GlobalSearch_content__3AyQ3"};